module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1298.391005c9.png";